import React from "react";

import { FIELD_TYPE } from "types/enums";
import { DataFormField } from "types/models/input-field-type";

import { ColumnProps } from "../../../../../types/models";

const { INPUT, TEXT_AREA } = FIELD_TYPE;

const listMonths = [];
for (let month = 1; month <= 12; month++) {
  listMonths.push({
    value: month,
    label: `Tháng ${month}`,
  });
}

//--------------------------------------------------------
const listYears = [];
const currentYear = new Date().getFullYear();
const startYear = 2020;
const endYear = currentYear + 100;
for (let year = startYear; year <= endYear; year++) {
  listYears.push({
    value: year,
    label: year.toString(),
  });
}

const allColumns: ColumnProps[] = [
  {
    title: "STT",
    key: "index",
    show: true,
    dataIndex: "index",
    render(_, __, index) {
      return <>{index + 1}</>;
    },
    disabledCheck: true,
    width: 40,
    align: "center",
    isResizable: true,
  },
  {
    title: "Mã quyền duyệt",
    key: "maQuyenDuyet",
    show: true,
    dataIndex: "maQuyenDuyet",
    width: 90,
    align: "center",
    isResizable: true,
  },
  {
    title: "Tên quyền duyệt",
    key: "tenQuyenDuyet",
    show: true,
    isResizable: true,
    dataIndex: "tenQuyenDuyet",
    width: 150,
    align: "left",
  },
  {
    title: "Ghi chú",
    key: "ghiChu",
    show: true,
    isResizable: true,
    dataIndex: "ghiChu",
    width: 60,
    align: "left",
  },
  {
    title: "Từ trạng thái",
    key: "tuTrangThai",
    show: true,
    isResizable: true,
    dataIndex: "tuTrangThai",
    width: 60,
    align: "left",
  },
  {
    title: "Trạng thái duyệt",
    key: "trangThaiDuyet",
    show: true,
    isResizable: true,
    dataIndex: "trangThaiDuyet",
    width: 60,
    align: "left",
  },
  {
    title: "Trạng thái hủy",
    key: "trangThaiHuy",
    show: true,
    isResizable: true,
    dataIndex: "trangThaiHuy",
    width: 60,
    align: "left",
  },
  {
    title: "Không nhận thông tin duyệt",
    key: "trangThaiHuy",
    show: true,
    isResizable: true,
    dataIndex: "trangThaiHuy",
    width: 60,
    align: "left",
  },
  {
    title: "Gửi thông tin cho người duyệt trước",
    key: "baoNguoiDuyetTruoc",
    show: true,
    isResizable: true,
    dataIndex: "baoNguoiDuyetTruoc",
    width: 60,
    align: "left",
  },
  {
    title: "Gửi thông tin cho người tạo",
    key: "trangThaiHuy",
    show: true,
    isResizable: true,
    dataIndex: "trangThaiHuy",
    width: 60,
    align: "left",
  },
];

const itemsInputField: DataFormField[] = [
  {
    type: INPUT,
    label: "Mã quyền duyệt",
    name: "maQuyenDuyet",
    disable: false,
  },
  {
    type: INPUT,
    name: "tenQuyenDuyet",
    label: "Tên quyền duyệt",
    disable: false,
  },
  {
    type: TEXT_AREA,
    name: "ghiChu",
    label: "Ghi chú",
    disable: false,
  },
];

export { allColumns, itemsInputField };
